import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";
import logo from "../assets/gatorhead.png";
import { CohortCard, MemberCard } from "../components/MemberCard";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import data from "../data/cohort.js";
import Ronald_pres from "../assets/optimized/eboard/Ronald_pres.webp";
import Ronald_O from "../assets/optimized/eboard/Ronald_O.webp";
import Lukas_O from "../assets/optimized/eboard/Lukas_O.webp";
import Amy_O from "../assets/optimized/eboard/Amy_O.webp";
import Kaiya_O from "../assets/optimized/eboard/Kaiya_O.webp";
import Mackenzie_O from "../assets/optimized/eboard/Mackenzie_O.webp";
import Mackenzie_hpr from "../assets/optimized/eboard/Mackenzie_hpr.webp";
import Kaiya_tres from "../assets/optimized/eboard/Kaiya_tres.webp";
import Lukas_vp from "../assets/optimized/eboard/Lukas_vp.webp";
import Amy_sec from "../assets/optimized/eboard/Amy_sec.webp";
import Bryce_O from "../assets/optimized/eboard/Brycenoglasses.webp";
import Arely from "../assets/optimized/eboard/Arely.webp";
import Bethany from "../assets/optimized/eboard/Bethany.webp";
import Bonnie from "../assets/optimized/eboard/Bonnie.webp";
import Brianna from "../assets/optimized/eboard/Brianna.webp";
import Claira from "../assets/optimized/eboard/Claira.webp";
import Diomary from "../assets/optimized/eboard/Diomary.webp";
import Hillary from "../assets/optimized/eboard/Hillary.webp";
import Jennifer from "../assets/optimized/eboard/Jennifer.webp";
import Cristian_O from "../assets/optimized/eboard/Cristian_O.webp";
import jackson_O from "../assets/optimized/eboard/Jackson_O.webp";
import Paloma_O from "../assets/optimized/eboard/Paloma_O.webp";
import Alana_O from "../assets/optimized/eboard/Alana_O.webp";
import Isaac_O from "../assets/optimized/eboard/Isaac_O.webp";
import Jon_O from "../assets/optimized/eboard/Jon_O.webp";
import Cali_O from "../assets/optimized/eboard/Cali_O.webp";
import Yeneisi_O from "../assets/optimized/eboard/Yeneisi_O.webp";
import Tyrese_O from "../assets/optimized/eboard/Tyrese_O.webp";
import Nick_O from "../assets/optimized/eboard/Nick_O.webp";
import Anthony_O from "../assets/optimized/eboard/anthony_O.webp";
import Santi_O from "../assets/optimized/eboard/Santiglasses.webp";
import Maria_O from "../assets/optimized/eboard/Maria_O.webp";
import Karma from "../assets/optimized/eboard/Karma.webp";
import Ketlove from "../assets/optimized/eboard/Ketlove.webp";
import Khan from "../assets/optimized/eboard/Khan.webp";
import Lauren from "../assets/optimized/eboard/Lauren.webp";
import Lissy from "../assets/optimized/eboard/Lissy.webp";
import Marcela from "../assets/optimized/eboard/Marcela.webp";
import Melani from "../assets/optimized/eboard/Melani.webp";
import Nicky from "../assets/optimized/eboard/Nicky.webp";
import Pablo from "../assets/optimized/eboard/Pablo.webp";
import Marianne_O from "../assets/optimized/eboard/Marianne_O.webp";
import Rachel_O from "../assets/optimized/eboard/Rachel_O.webp";
import Camily_O from "../assets/optimized/eboard/Camily_O.webp";
import Jaily_O from "../assets/optimized/eboard/Jaily_O.webp";
import Thinh from "../assets/optimized/eboard/Thinh.webp";
import Yaxiel from "../assets/optimized/eboard/Yaxiel.webp";
import Alana from "../assets/cohort/Alana.jpg";
import Alivia from "../assets/cohort/Alivia.jpg";
import Alvaro from "../assets/cohort/Alvaro.jpg";
import Alyanna from "../assets/cohort/Alyanna.jpg";
import Amy from "../assets/cohort/Amy.jpg";
import Angelina from "../assets/cohort/Angelina.jpg";
import Angelique from "../assets/cohort/Angelique.jpg";
import Anthony from "../assets/cohort/Anthony.jpg";
import Antonio from "../assets/cohort/Antonio.jpg";
import Anwita from "../assets/cohort/Anwita.jpg";
import Bryce from "../assets/cohort/Bryce.jpg";
import Cali from "../assets/cohort/Cali.jpg";
import Camily from "../assets/cohort/Camily.jpg";
import ChristianM from "../assets/cohort/nophoto.jpg";
import ChristianP from "../assets/cohort/ChristianP.jpg";
import Cielo from "../assets/cohort/Cielo.jpg";
import Cristian from "../assets/cohort/Cristian.jpg";
import Deanna from "../assets/cohort/Deanna.jpg";
import Douglas from "../assets/cohort/Douglas.jpg";
import Erick from "../assets/cohort/Erick.jpg";
import Isaac from "../assets/cohort/Isaac.jpg";
import Jackson from "../assets/cohort/Jackson.jpg";
import Jaily from "../assets/cohort/Jaily.jpg";
import Jeremiah from "../assets/cohort/Jeremiah.jpg";
import Jon from "../assets/cohort/Jon.jpg";
import Kaiya from "../assets/cohort/Kaiya.jpg";
import Katherine from "../assets/cohort/Katherine.jpg";
import Lukas from "../assets/cohort/Lukas.jpg";
import Mackenzie from "../assets/cohort/Mackenzie.jpg";
import Maria from "../assets/cohort/Maria.jpg";
import Marianne from "../assets/cohort/Marianne.jpg";
import Melissa from "../assets/cohort/Melissa.jpg";
import Megan from "../assets/cohort/Megan.jpg";
import Melvin from "../assets/cohort/Melvin.jpg";
import Mishka from "../assets/cohort/Mishka.jpg";
import Nicholas from "../assets/cohort/Nicholas.jpg";
import Nickolas from "../assets/cohort/Nickolas.jpg";
import Noah from "../assets/cohort/Noah.jpg";
import Paloma from "../assets/cohort/Paloma.jpg";
import Peter from "../assets/cohort/Peter.jpg";
import Rachel from "../assets/cohort/Rachel.jpg";
import Renisha from "../assets/cohort/Renisha.jpg";
import Sabrina from "../assets/cohort/Sabrina.jpg";
import Santiago from "../assets/cohort/Santiago.jpg";
import Taisiya from "../assets/cohort/nophoto.jpg";
import Trevor from "../assets/cohort/nophoto.jpg";
import Tyrese from "../assets/cohort/Tyrese.jpg";
import Wasseem from "../assets/cohort/nophoto.jpg";
import Xansibella from "../assets/cohort/Xansibella.jpg";
import Yeneisi from "../assets/cohort/Yeneisi.jpg";
import "./Members.css";

const Members = () => {
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [isOpen6, setIsOpen6] = useState(true);
  const [isOpen7, setIsOpen7] = useState(false)

  const cohortImages = [
    Alana,
    Alivia,
    Alvaro,
    Alyanna,
    Amy,
    Angelina,
    Angelique,
    Anthony,
    Antonio,
    Anwita,
    Bryce,
    Cali,
    Camily,
    ChristianM,
    ChristianP,
    Cielo,
    Cristian,
    Deanna,
    Douglas,
    Erick,
    Isaac,
    Jackson,
    Jaily,
    Jeremiah,
    Jon,
    Kaiya,
    Katherine,
    Lukas,
    Mackenzie,
    Maria,
    Marianne,
    Megan,
    Melissa,
    Melvin,
    Mishka,
    Nicholas,
    Nickolas,
    Noah,
    Paloma,
    Peter,
    Rachel,
    Renisha,
    Sabrina,
    Santiago,
    Taisiya,
    Trevor,
    Tyrese,
    Wasseem,
    Xansibella,
    Yeneisi,
  ];

  const handleOnClick = (isOpen, num) => {
    if (num === 1) {
      if (isOpen) {
        setIsOpen1(false);
      } else {
        setIsOpen1(true);
      }
    } else if (num === 2) {
      if (isOpen) {
        setIsOpen2(false);
      } else {
        setIsOpen2(true);
      }
    } else if (num === 3) {
      if (isOpen) {
        setIsOpen3(false);
      } else {
        setIsOpen3(true);
      }
    } else if (num === 4) {
      if (isOpen) {
        setIsOpen4(false);
      } else {
        setIsOpen4(true);
      }
    } else if (num === 5) {
      if (isOpen) {
        setIsOpen5(false);
      } else {
        setIsOpen5(true);
      }
    } else if (num === 6) {
      if (isOpen) {
        setIsOpen6(false);
      } else {
        setIsOpen6(true);
      }
    }
    else if (num === 7) {
      if (isOpen) {
        setIsOpen7(false);
      } else {
        setIsOpen7  (true);
      }
    }
  };

  return (
    <div className="members-div">
      <div className="members-faux-title"></div>
      <div className="members-title-div">
        <div className="members-divider"></div>
        <Fade>
          <div className="members-title-container">
            <img className="members-image" src={logo} alt="" />
            <h1 className="members-title">Members</h1>
          </div>
        </Fade>
        <div className="members-divider"></div>
      </div>
      <div className="members-subtitle">Executive Board</div>
      <div className="members-subtitle-div-background">
        <div className="members-subtitle-divider"></div>
      </div>
      <div className="members-photogrid">
        <MemberCard
          image={Ronald_O}
          name="Ronald Lazo"
          position="President"
        ></MemberCard>
        <MemberCard
          image={Lukas_O}
          name="Lukas Gibbs"
          position="Vice President"
        ></MemberCard>
         <MemberCard
          image={Amy_O}
          name="Amy Kollcinaku"
          position="Secretary"
        ></MemberCard>
        <MemberCard
          image={Kaiya_O}
          name="Kaiya Varner"
          position="Treasurer"
        ></MemberCard>
        <MemberCard
          image={Mackenzie_O}
          name="Mackenzie Connole"
          position="Head of Public Relations"
        ></MemberCard>
        <MemberCard
          image={Bryce_O} 
          name="Bryce Moore"
          position="Chief of staff"
        ></MemberCard>
        <MemberCard
          image={Cristian_O}
          name="Cristian Alicea"
          position="Service Director"
        ></MemberCard>
        <MemberCard
          image={jackson_O}
          name="Jackson Le"
          position="Service Director"
        ></MemberCard>
        <MemberCard
          image={Jaily_O}
          name="Jaily De Paula"
          position="GBM Director"
        ></MemberCard>
        <MemberCard
          image={Marianne_O}
          name="Marianne Franco"
          position="GBM Director"
        ></MemberCard>
        <MemberCard
          image={Rachel_O}
          name="Rachel Oria"
          position="Special Events Director"
        ></MemberCard>
        <MemberCard
          image={Camily_O}
          name="Camily De Paula"
          position="Special Events Director"
        ></MemberCard>
        <MemberCard
          image={Alana_O}
          name="Alana Cross"
          position="Mentorship Director"
        ></MemberCard>
        <MemberCard
          image={Paloma_O}
          name="Paloma Rodriguez"
          position="Marketing Director"
        ></MemberCard>
        <MemberCard
          image={Isaac_O}
          name="Isaac Aristud"
          position="Marketing Director"
        ></MemberCard>
        <MemberCard
          image={Jon_O}
          name="Jon Sarmento"
          position="Finance Director"
        ></MemberCard>
        <MemberCard
          image={Tyrese_O}
          name="Tyrese Dorce"
          position="Socials Director"
        ></MemberCard>
        <MemberCard
          image={Yeneisi_O}
          name="Yeneisi Calihua-Panzo"
          position="Socials Director"
        ></MemberCard>
        <MemberCard
          image={Cali_O}
          name="Cali Copeland"
          position="Socials Director"
          ></MemberCard>
        <MemberCard
          image={Maria_O}
          name="Maria Leon"
          position="Programming Director"
        ></MemberCard>
        <MemberCard
          image={Nick_O}
          name="Nickolas Hebert"
          position="Programming Director"
        ></MemberCard>
        <MemberCard
          image={Anthony_O}
          name="Anthony Rodriguez"
          position="Professional Opportunity Director"
        ></MemberCard>
        <MemberCard
          image={Santi_O}
          name="Santiago Ramirez"
          position="Website Director"
        ></MemberCard>
      </div> 
      {/* <div className="members-subtitle-div">
        <div className="members-subtitle">Cohort 2022 - 2023</div>
        <MdOutlineKeyboardArrowDown
          className="members-subtitle-button"
          size={40}
          onClick={() => {
            handleOnClick(isOpen1, 1);
          }}
        ></MdOutlineKeyboardArrowDown>
      </div>
      <div className="members-subtitle-div-background">
        <div className="members-subtitle-divider"></div>
      </div>
      <div className="cohort-members-photogrid">
        {isOpen1 ? (
          data.cohort22_23.map((name, index) => {
            return (
              <CohortCard name={name} image={cohortImages[index]}></CohortCard>
            );
          })
        ) : (
          <div></div>
        )}
      </div> */}
      <div className="members-subtitle-div">
      <div className="members-subtitle">Cohort 2026 - 2027</div>
        <MdOutlineKeyboardArrowDown
          className="members-subtitle-button"
          size={40}
          onClick={() => {
           setIsOpen7(!isOpen7);
          }}
        ></MdOutlineKeyboardArrowDown>
      </div>
      <div className="members-subtitle-div-background">
        <div className="members-subtitle-divider"></div>
      </div>
      <div className="cohort-members-photogrid">
        {isOpen7 ? (
          data.cohort26_27.map((name) => {
            return (
              <div className="cohort-member-name-div">
                <p className="cohort-member-name">{name}</p>
              </div>
            );
          })
        ) : (
          <div></div>
        )}
      </div>
      <div className="members-subtitle-div">
        <div className="members-subtitle">Cohort 2025 - 2026</div>
        <MdOutlineKeyboardArrowDown
          className="members-subtitle-button"
          size={40}
          onClick={() => {
            handleOnClick(isOpen6, 6);
          }}
        ></MdOutlineKeyboardArrowDown>
      </div>
      <div className="members-subtitle-div-background">
        <div className="members-subtitle-divider"></div>
      </div>
      <div className="cohort-members-photogrid">
        {isOpen6 ? (
          data.cohort25_26.map((name,index) => {
            //if(index !== 13 && index !== 44 && index !== 45 && index !== 47){
              //return (
                // <div className="cohort-member-name-div">
                //   <p className="cohort-member-name">{name}</p>
                // </div>
                /* <CohortCard
                  image={cohortImages[index]}
                  name={name}
                ></CohortCard>
              );
            } */
              return (
              <div className="cohort-member-name-div">
                <p className="cohort-member-name">{name}</p>
              </div>
              );
            })
    
            )  : (
          <div></div>
        )}
      </div>
      <div className="members-subtitle-div">
        <div className="members-subtitle">Cohort 2024 - 2025</div>
        <MdOutlineKeyboardArrowDown
          className="members-subtitle-button"
          size={40}
          onClick={() => {
            handleOnClick(isOpen5, 5);
          }}
        ></MdOutlineKeyboardArrowDown>
      </div>
      <div className="members-subtitle-div-background">
        <div className="members-subtitle-divider"></div>
      </div>
      <div className="cohort-members-photogrid">
        {isOpen5 ? (
          data.cohort24_25.map((name) => {
            return (
              <div className="cohort-member-name-div">
                <p className="cohort-member-name">{name}</p>
              </div>
            );
          })
        ) : (
          <div></div>
        )}
      </div>

      <div className="members-subtitle-div">
        <div className="members-subtitle">Cohort 2023 - 2024</div>
        <MdOutlineKeyboardArrowDown
          className="members-subtitle-button"
          size={40}
          onClick={() => {
            handleOnClick(isOpen4, 4);
          }}
        ></MdOutlineKeyboardArrowDown>
      </div>
      <div className="members-subtitle-div-background">
        <div className="members-subtitle-divider"></div>
      </div>
      <div className="cohort-members-photogrid">
        {isOpen4 ? (
          data.cohort23_24.map((name) => {
            return (
              <div className="cohort-member-name-div">
                <p className="cohort-member-name">{name}</p>
              </div>
            );
          })
        ) : (
          <div></div>
        )}
      </div>
      <div className="members-subtitle-div">
        <div className="members-subtitle">Cohort 2022 - 2023</div>
        <MdOutlineKeyboardArrowDown
          className="members-subtitle-button"
          size={40}
          onClick={() => {
            handleOnClick(isOpen3, 3);
          }}
        ></MdOutlineKeyboardArrowDown>
      </div>
      <div className="members-subtitle-div-background">
        <div className="members-subtitle-divider"></div>
      </div>
      <div className="cohort-members-photogrid">
        {isOpen3 ? (
          data.cohort22_23.map((name) => {
            return (
              <div className="cohort-member-name-div">
                <p className="cohort-member-name">{name}</p>
              </div>
            );
          })
        ) : (
          <div></div>
        )}
      </div>
      <div className="members-subtitle-div">
        <div className="members-subtitle">Cohort 2021 - 2022</div>
        <MdOutlineKeyboardArrowDown
          className="members-subtitle-button"
          size={40}
          onClick={() => {
            handleOnClick(isOpen2, 2);
          }}
        ></MdOutlineKeyboardArrowDown>
      </div>
      <div className="members-subtitle-div-background">
        <div className="members-subtitle-divider"></div>
      </div>
      <div className="cohort-members-photogrid">
        {isOpen2 ? (
          data.cohort21_22.map((name) => {
            return (
              <div className="cohort-member-name-div">
                <p className="cohort-member-name">{name}</p>
              </div>
            );
          })
        ) : (
          <div></div>
        )}
      </div>
      <div className="members-subtitle-div">
        <div className="members-subtitle">Cohort 2020 - 2021</div>
        <MdOutlineKeyboardArrowDown
          className="members-subtitle-button"
          size={40}
          onClick={() => {
            handleOnClick(isOpen1, 1);
          }}
        ></MdOutlineKeyboardArrowDown>
      </div>
      <div className="members-subtitle-div-background">
        <div className="members-subtitle-divider"></div>
      </div>
      <div className="cohort-members-photogrid">
        {isOpen1 ? (
          data.cohort20_21.map((name) => {
            return (
              <div className="cohort-member-name-div">
                <p className="cohort-member-name">{name}</p>
              </div>
            );
          })
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};

export default Members;
